export const visibilityStates = [
    {
        value: false,
        text: 'notPublic',
    },
    {
        value: true,
        text: 'public',
    }
];